import classNames from 'classnames';
import React, { useState } from 'react';
import OverflowMenu from '../../components/OverflowMenu';
import styles from './TopicUsersPanelRow.module.scss';

interface TopicUsersPanelRowProps {
  compact?: boolean;
  content: React.ReactNode;
  icon: React.ReactNode;
  menu?: React.ReactNode;
  onClick?: () => unknown;
}

const TopicUsersPanelRow = ({
  compact = false,
  content,
  icon,
  menu,
  onClick,
}: TopicUsersPanelRowProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited
    <div
      className={classNames(styles.row, {
        [styles.clickable]: onClick,
        [styles.menuOpen]: isMenuOpen,
        [styles.compact]: compact,
      })}
      onClick={onClick}
    >
      <div className={styles.icon}>{icon}</div>
      {content}
      {!!menu && (
        <div className={styles.overflowContainer}>
          <OverflowMenu
            open={isMenuOpen}
            onOpenChange={(value) => setIsMenuOpen(value)}
            iconSize="regular"
          >
            {menu}
          </OverflowMenu>
        </div>
      )}
    </div>
  );
};

export default TopicUsersPanelRow;
